import ofertaReferidorEmprendedores from "@/config/brands/ofertaReferidorEmprendedores";

describe("ofertaReferidorEmprendedores", () => {
  it("should have a googleAnalyticsId", () => {
    expect(ofertaReferidorEmprendedores.googleAnalyticsId).toBeNull();
  });

  it("should have a pasos object", () => {
    expect(typeof ofertaReferidorEmprendedores.pasos).toBe("object");
  });

  it("should have correct paths and components in pasos", () => {
    expect(ofertaReferidorEmprendedores.pasos.paso1).toEqual({
      path: "/",
      component: "views/ReferidosEmprendedores"
    });

    expect(ofertaReferidorEmprendedores.pasos.referidos).toEqual({
      path: "/:origen?",
      component: "views/ReferidosEmprendedores"
    });
  });
});
